import { divWrapperFor } from '../utils/wrapperFor';
import './SiteContainer.scss';

export const SiteContainer = divWrapperFor('site-container');
